import { render, staticRenderFns } from "./ItinerariesFilters.vue?vue&type=template&id=c388b1c0&scoped=true"
import script from "./ItinerariesFilters.vue?vue&type=script&lang=js"
export * from "./ItinerariesFilters.vue?vue&type=script&lang=js"
import style0 from "./ItinerariesFilters.vue?vue&type=style&index=0&id=c388b1c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c388b1c0",
  null
  
)

export default component.exports